import React, { Children, useState } from "react";

import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// import JS files
import MuiTheme from "./MuiTheme";

// import Others files

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  borderRadius: "0.5rem",
  "&:last-child": {
    borderBottom: "0",
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  borderRadius: "0.5rem",
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "#42A7C3",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    color: "#42A7C3",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: "#F9FAFC",
  borderTop: "1px solid #D9EEF366",
  borderBottom: "1px solid #D9EEF366",
  borderBottomLeftRadius: "0.5rem",
  borderBottomRightRadius: "0.5rem",
}));

const MuiCollapse = ({ expandedId, header, children }) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <MuiTheme>
        <Accordion
          expanded={expanded === expandedId}
          onChange={handleChange(expandedId)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography  sx={{ width: "100%", flexShrink: 0}}>
              {header}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>{children}</Typography>
          </AccordionDetails>
        </Accordion>
      </MuiTheme>
    </>
  );
};

export default MuiCollapse;
